<template>
    <div class="board-container">
        <table class="board-view">
            <tr>
                <th colspan="2">{{ notification?.subject }}</th>
            </tr>
            <tr>
                <td colspan="2">
                    <v-row class="row--small">
                        <v-col cols="auto">
                            <span>작성자 : 관리자</span>
                        </v-col>
                        <v-col cols="auto">
                            <span>작성일 : {{ $dayjs(notification?.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                        </v-col>
                        <v-col cols="auto">
                            <span>조회수 : {{ notification?.viewCount }}</span>
                        </v-col>
                    </v-row>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="content_box">
                    <div v-html="notification?.content.replace(/\n/g, '<br>')"></div>
                </td>
            </tr>
        </table>

        <v-row class="mt--md justify-end">
            <v-col cols="auto">
                <div class="pt-36 pt-md-54 pt-lg-74">
                    <v-btn outlined color="grey lighten-3" @click="$router.push('/service/notice')">
                        <span class="font-weight-medium font-pretendard grey--text">LIST</span>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

export default {
    components: {},
    data() {
        return {
            notification: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        download,
        async init() {
            try {
                var { notification } = await api.v1.center.notifications.get({ _id: this.$route.params._notification });
                // if (notification.upload) notification.upload = await api.getResource(notification.upload);
                this.notification = notification;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>
